import { BehaviorSubject } from 'rxjs';
import { useBehaviorSubjectValue } from './utils';
export const hasHighContrastReportTheme$ = new BehaviorSubject(false);
/**
 * Configures all reports to load with the High Contrast report theme.
 * When called, all open reports are reloaded to reflect the new setting.
 * @public
 */
export function setUseHighContrastReportTheme(value) {
    hasHighContrastReportTheme$.next(!!value);
}
export function getUseHighContrastReportTheme() {
    return hasHighContrastReportTheme$.getValue();
}
export function useHasHighContrastReportTheme() {
    return useBehaviorSubjectValue(hasHighContrastReportTheme$);
}
